import { render, staticRenderFns } from "./StyleForm.vue?vue&type=template&id=06ed7537&"
import script from "./StyleForm.vue?vue&type=script&lang=js&"
export * from "./StyleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports